import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import blogImg from "../assets/home_carousel_1.webp";
import emiImg from "../assets/home_carousel_2.webp";
import branchImg from "../assets/home_carousel_3.webp";
import loanImg from "../assets/home_carousel_4.webp";
import contactImg from "../assets/home_carousel_5.webp";
import { LazyImageComponent } from "../components/lazyloader/LazyImage";
import { Link } from "react-router-dom";

export default function ServiceGrid() {
  const SlideContent = () => (
    <div className="slide-inner">
      <div className="row g-0 align-items-stretch">
        <div className="col-6 col-md-3 p-1 d-flex">
          <div
            className="service-img"
            style={{
              position: "relative",
              borderRadius: "12px",
              overflow: "hidden",
              flex: 1,
              height: "100%",
              minHeight: "220px",
            }}
          >
            <LazyImageComponent
              src={blogImg}
              alt="Blogs"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
                display: "block",
              }}
            />
            <div
              className="service-text"
              style={{
                position: "absolute",
                bottom: "10px",
                left: "20px",
                color: "#fff",
                fontWeight: "600",
                fontSize: "1.2rem",
              }}
            >
              Explore Our <br /> Latest Blogs
            </div>
          </div>
        </div>

        <div className="col-6 col-md-3 p-1 d-flex flex-column justify-content-between">
          <div
            className="mb-2 flex-fill service-small"
            style={{
              position: "relative",
              borderRadius: "12px",
              overflow: "hidden",
              flex: 1,
              minHeight: "105px",
            }}
          >
            <LazyImageComponent
              src={emiImg}
              alt="EMI"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
                display: "block",
              }}
            />
            <div
              className="service-text"
              style={{
                position: "absolute",
                top: "20px",
                left: "10px",
                color: "#fff",
                fontWeight: "600",
                fontSize: "1.1rem",
              }}
            >
              Emi <br /> Calculator
            </div>
          </div>

          <div
            className="flex-fill service-small"
            style={{
              position: "relative",
              borderRadius: "12px",
              overflow: "hidden",
              flex: 1,
              minHeight: "105px",
            }}
          >
            <LazyImageComponent
              src={branchImg}
              alt="Branch"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
                display: "block",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "10px",
                left: "10px",
              }}
            >
              <Link to="/locate">
                <button
                  className="service-btn"
                  style={{
                    backgroundColor: "#f8a541",
                    border: "none",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "4px 10px",
                    fontWeight: "600",
                    fontSize: "0.8rem",
                    cursor: "pointer",
                  }}
                >
                  LOCATE US
                </button>
              </Link>
            </div>
          </div>
        </div>

        <div className="col-6 col-md-3 p-1 d-flex">
          <div
            className="service-img"
            style={{
              position: "relative",
              borderRadius: "12px",
              overflow: "hidden",
              flex: 1,
              minHeight: "220px",
            }}
          >
            <LazyImageComponent
              src={loanImg}
              alt="Loan"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
                display: "block",
              }}
            />
            <div
              className="p-3 service-text"
              style={{
                position: "absolute",
                top: "5px",
                left: "6px",
                right: "0",
                color: "#fff",
                fontWeight: "700",
                fontSize: "1.2rem",
              }}
            >
              Instant Loan With
              <br /> No Hidden Charges
            </div>
          </div>
        </div>

        <div className="col-6 col-md-3 p-1 d-flex">
          <div
            className="service-img"
            style={{
              position: "relative",
              borderRadius: "12px",
              overflow: "hidden",
              flex: 1,
              minHeight: "220px",
            }}
          >
            <LazyImageComponent
              src={contactImg}
              alt="Contact"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
                display: "block",
              }}
            />
            <div
              className="p-3 service-text"
              style={{
                position: "absolute",
                top: "5px",
                left: "6px",
                color: "#fff",
                fontWeight: "600",
                fontSize: "1.2rem",
              }}
            >
              For More Services
              <br />
              and Queries
            </div>
            <div
              style={{
                position: "absolute",
                bottom: "10px",
                left: "10px",
              }}
            >
               <Link to="/contact">
              <button
                className="service-btn"
                style={{
                  backgroundColor: "#f8a541",
                  border: "none",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "6px 10px",
                  fontWeight: "600",
                  fontSize: "0.8rem",
                }}
              >
                CONTACT US
              </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="py-3 overflow-hidden">
      <style>
        {`
          .scroller {
            width: 100%;
            overflow: hidden;
            position: relative;
            background: transparent;
          }

          .scroller-track {
            display: flex;
            width: 200%;
            animation: scroll-left 30s linear infinite;
            align-items: stretch;
            gap: 0;
          }

          .slide {
            flex: 0 0 50%;
            box-sizing: border-box;
            padding-right: 0;
          }

          .slide-inner { width: 100%; box-sizing: border-box; }

          .slide-inner .row { margin: 0; }
          .slide-inner .col-6,
          .slide-inner .col-md-3 { padding: 0; box-sizing: border-box; }

          .scroller:hover .scroller-track { animation-play-state: paused; }

          @keyframes scroll-left {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          .service-img { position: relative; border-radius: 12px; overflow: hidden; background: transparent; }
          .service-small { position: relative; border-radius: 12px; overflow: hidden; background: transparent; }

          /* Desktop sizes  */
          .service-img { min-height: 220px; }
          .service-small { min-height: 105px; }

          /* mobile adjustments */
          @media (max-width: 768px) {
            .service-img { min-height: 120px !important; }
            .service-small { min-height: 80px !important; }
            .service-text { font-size: 0.9rem !important; }
            .service-btn { padding: 3px 8px !important; font-size: 0.7rem !important; }
            .scroller-track { animation-duration: 16s; } 
          }

          @media (max-width: 576px) {
            .service-img { min-height: 100px !important; }
            .service-small { min-height: 60px !important; }
            .scroller-track { animation-duration: 12s; }
          }
        `}
      </style>

      <div className="scroller" aria-hidden={false}>
        <div className="scroller-track">
          <div className="slide">
            <SlideContent />
          </div>

          <div className="slide" aria-hidden="true">
            <SlideContent />
          </div>
        </div>
      </div>
    </div>
  );
}
